module.exports = __webpack_public_path__ + "static/img/Frame 1850.76d1573.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls3/Frame 1850.png
// module id = 1SrK
// module chunks = 12